export default {
  username: '',
  password: '',
};
